export default __webpack_public_path__ + "static/media/runkeeper-phones-overview.69ce9d1e.png";